export const breakpoints = {
    mobile: 320,
    desktopMinimum: 480,
    tablet: 1024,
    desktopCompact: 1140,
    desktop: 1280,
};
export const mediaQueries = {
    from: (bp) => `@media screen and (width >= ${breakpoints[bp]}px)`,
    upTo: (bp) => `@media screen and (width < ${breakpoints[bp]}px)`,
    between: (bp1, bp2) => `@media screen and (width >= ${breakpoints[bp1]}px) and (width < ${breakpoints[bp2]}px)`,
};
//# sourceMappingURL=breakpoints.js.map